module.exports = __webpack_public_path__ + "img/book-half.eb9dc919.svg";